import { useNavigate, Link, useLocation } from "react-router-dom";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { Fragment, useContext, useState, useEffect } from "react";
import AdminListTable from "./AdminListTable";
import { Button, ButtonGroup, Card, CardBody, CardTitle, Container, Dropdown, DropdownButton } from "react-bootstrap";
// import 'bootstrap/dist/js/bootstrap.bundle';
import DashboardHeader from "../../../Components/Dashboard/DashboardHeader";
import TokenService from '../../../Services/Token.service';
import ClearFilterButton from "../../../Components/ClearFilterButton";
import { Helmet } from "react-helmet";
import { ToastContext, useToast } from "../../../Components/ToastProvider";
import Toaster from "../../../Components/Toaster";
import { useMediaQuery } from "react-responsive";

function AdminManagement() {
    const navigate = useNavigate();
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };
    const previousUrl = TokenService.getPrevLink();

    useEffect(() => {
        console.log("Idle Status Before ", localStorage.getItem('isIdle'));
    }, []);
    const location = useLocation();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant);
            // showToast(location.state.toastMessage, location.state.toastVariant);

                // Clear location.state to prevent the toast from triggering on refresh
                navigate(location.pathname, { replace: true }); 
        }
    },[], [location.state, showToast, navigate]);
    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <Fragment>
            <Helmet>
                <title>DonorX | Admin Management</title>
            </Helmet>
            {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
            {/* <DashboardHeader/> */}
            <div className="el-middle-wrapper">
                <h2 className="el-title">Admin Management</h2>
                <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrative Settings</Link>

                <div className={`${isMobile ? 'mt-3' : 'el-bg-table'}`}>
                    <div className="d-flex justify-content-between">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{ marginRight: '15px' }}>
                                <h3>Admin List</h3>
                            </div>
                            {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                            {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                        </div>
                        <div className="d-flex justify-content-around"> 
                            <div>
                                <Dropdown>
                                    <Dropdown.Toggle variant="secondary" className="navbar-drop-buttons" id="dropdown-basic">
                                        <span>New Admin</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="el-admin">
                                        <Dropdown.Item onClick={() =>{TokenService.updatePrevLink('/admin/admin-management'); navigate('add-admin/superadmin')}}>
                                            Super Admin (full control)
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => {TokenService.updatePrevLink('/admin/admin-management'); navigate('add-admin/admin')}}>
                                            Admin (managed control)
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> 
                            </div>
                        </div>
                    </div>
                    <>
                        <AdminListTable isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange} />
                    </>
                </div>
            </div>
            {/* </div> */}
            <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
        </Fragment>
    );
}
export default AdminManagement;